export const categories = [
  {
    name: "entertaiment",
    pattern: ["spotify", "disc prem", "netflix"],
    color: "#1F629C",
  },
  {
    name: "food",
    pattern: [
      "checkers",
      "pnp",
      "mcd",
      "groceries",
      "jerrys",
      "forneria",
      "seattle",
      "healthfood",
      "sushi",
      "vida e cafe",
      "superspar",
      "woolworths",
      "food",
      "sweets",
    ],
    color: "#0163B8",
  },
  {
    name: "bank",
    pattern: ["account fee"],
    color: "#8CA9C2",
  },
  {
    name: "household",
    pattern: ["electricity", "plaster"],
    color: "#76C2B6",
  },
  {
    name: "transport",
    pattern: ["uber", "petrol", "airline", "caltex"],
    color: "#4A8C9A",
  },
  {
    name: "medical",
    pattern: ["dischem mountain", "wellness", "clicks"],
    color: "#4A579A",
  },
  {
    name: "personal",
    pattern: ["waterfront", "superlist", "animal", "pets"],
    color: "#6778CD",
  },
  {
    name: "communication",
    pattern: ["airtime", "google"],
    color: "#1A2B82",
  },
]
